(() => {
 const initialize = (root = document) => {
  const service = new URLSearchParams(location.search).get('service')?.replaceAll('Full-Service','Full Service');
  root.querySelectorAll('select[name="contact[service]"]').forEach(select => { if ([...select.options].some(o => o.value === service)) select.value = service; });
  root.querySelectorAll('.pmb-desktop-nav a,.pmb-mobile-nav a').forEach(a => {
    const u = new URL(a.href); if(u.pathname === location.pathname && u.searchParams.get('view') === new URLSearchParams(location.search).get('view')) a.setAttribute('aria-current','page');
  });
 };
 initialize();
 document.addEventListener('shopify:section:load', event => initialize(event.target));
 document.addEventListener('shopify:block:select', event => {
   const details = event.target.closest('details');
   if (details) details.open = true;
 });
})();
